<template>
    <footer>
        Copyright © 2022 <img src="@/assets/images/pixnet__logo.png" /> 優像數位媒體科技 ( 股 ) 公司
    </footer>
</template>

<style lang="scss" scoped>
@import '@/styles/theFooter';

</style>
